import { MesaMonogram } from '@/src/assets/icons/MesaMonogram'
import { MesaMortgageLogo } from '@/src/assets/icons/MesaMortgageLogo'
import { MesaHeader } from '@/src/common/modules/RewardsSection/MesaHeader'
import { View, Image } from 'react-native'
import { mesaColorNames } from '@/src/common/theme'

export function Header({ imageUrl }: { imageUrl?: string }) {
  // Default to Mesa Mortgage Header
  if (!imageUrl) {
    return (
      <MesaHeader>
        <MesaMonogram />
        <View style={{ position: 'absolute', margin: 'auto', alignItems: 'center' }}>
          <MesaMortgageLogo height={119} width={285} />
        </View>
      </MesaHeader>
    )
  }

  // Display to Partner Mortgage Header
  return (
    <MesaHeader
      style={{
        borderBottom: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: '#1B449D',
      }}
    >
      <View
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Image
          resizeMode={'contain'}
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
          }}
          source={{
            uri: imageUrl,
          }}
        />
      </View>
    </MesaHeader>
  )
}
